import React from 'react';
import { colors } from '@styleseat/brand';

type ProAvatarPlaceholderIconProps = {
  width?: number;
  height?: number;
  backgroundColor?: string;
  fillColor?: string;
  outlineColor?: string;
} & React.SVGProps<SVGSVGElement>;

export const ProAvatarPlaceholderIcon = ({
  width = 24,
  height = 24,
  backgroundColor = colors.chill,
  fillColor = colors.whiteWash,
  outlineColor = colors.blackInBlack,
}: ProAvatarPlaceholderIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 46C11.8497 46 2 36.1503 2 24C2 11.8497 11.8497 2 24 2C36.1503 2 46 11.8497 46 24C46 36.1503 36.1503 46 24 46Z"
      fill={outlineColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42Z"
      fill={backgroundColor}
    />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="6"
      y="6"
      width="36"
      height="36"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42Z"
        fill="#F3F0E2"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        d="M23 30.9999C15.8 30.5999 11 33.4999 9.5 34.9999C10.5 36.1666 13 38.8999 15 40.4999C17.5 42.4999 24.5 41.4999 27.5 41.9999C29.9 42.3999 34.8333 37.4999 37 34.9999C35.3333 33.8332 30.2 31.3999 23 30.9999Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 20C16 15.5115 19.1582 12 24 12C28.8284 12 32 15.8432 32 20.4C32 26.9592 28.4362 30 24 30C19.5217 30 16 26.8547 16 20Z"
        fill={outlineColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 20C20 24.5385 21.6364 26 24 26C26.3554 26 28 24.5968 28 20.4C28 17.9008 26.4313 16 24 16C21.4675 16 20 17.6316 20 20Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3477 40C10.1555 39.1605 9.05047 38.2055 8.04883 37.1513C8.6474 32.0897 14.7111 30 24 30C33.2889 30 39.3526 32.0897 39.9512 37.1513C38.9496 38.2055 37.8445 39.1605 36.6523 40H36V38C36 35.6042 31.7116 34 24 34C16.2884 34 12 35.6042 12 38V40H11.3477Z"
        fill={outlineColor}
      />
    </g>
  </svg>
);

export default ProAvatarPlaceholderIcon;
